"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SingleValueConverter = exports.KeyValueConverter = void 0;
var _remeda = require("remeda");
var _chainClient = require("@blockwell/chain-client");
function convertValue(funcs, val) {
  if ((0, _chainClient.isPrimitiveResponse)(val)) {
    for (let func of funcs) {
      if (func) {
        val = func(val);
      }
    }
    return val;
  } else if ((0, _chainClient.isArrayResponse)(val)) {
    return val.map(it => convertValue(funcs, it));
  } else {
    return Object.fromEntries(Object.entries(val).map(([key, val]) => [key, convertValue(funcs, val)]));
  }
}
function singleConvertFunction(funcs) {
  return value => {
    return convertValue(funcs, value);
  };
}
class SingleValueConverter {
  constructor(conversions) {
    this.conversions = conversions;
  }
  create(batcher) {
    let promised = false;
    let created = [];
    for (let it of this.conversions) {
      let func = it.type.create(it.deps, batcher);
      created.push(func);
      if ((0, _remeda.isPromise)(func)) {
        promised = true;
      }
    }
    if (promised) {
      return Promise.all(created).then(funcs => {
        return singleConvertFunction(funcs);
      });
    } else {
      return singleConvertFunction(created);
    }
  }
}
exports.SingleValueConverter = SingleValueConverter;
function keyedConvertFunction(funcs) {
  return value => {
    if ((0, _chainClient.isArrayResponse)(value)) {
      return value.map(it => {
        return Object.fromEntries(Object.entries(it).map(([key, val]) => {
          if (funcs[key]) {
            return [key, funcs[key](val)];
          }
          return [key, val];
        }));
      });
    }
    if ((0, _chainClient.isStructResponse)(value)) {
      return Object.fromEntries(Object.entries(value).map(([key, val]) => {
        if (funcs[key]) {
          return [key, funcs[key](val)];
        }
        return [key, val];
      }));
    }
    return value;
  };
}
class KeyValueConverter {
  constructor(conversions) {
    this.conversions = conversions;
  }
  create(batcher) {
    let promised = false;
    let created = {};
    for (let [key, conv] of Object.entries(this.conversions)) {
      let func = conv.create(batcher);
      created[key] = func;
      if ((0, _remeda.isPromise)(func)) {
        promised = true;
      }
    }
    if (promised) {
      return (async () => {
        let awaited = {};
        for (let [key, val] of Object.entries(created)) {
          awaited[key] = await val;
        }
        return keyedConvertFunction(awaited);
      })();
    } else {
      return keyedConvertFunction(created);
    }
  }
}
exports.KeyValueConverter = KeyValueConverter;
//# sourceMappingURL=ValueConverter.js.map